/*
 * The behaviour that belongs to every page: opening the menu on a small screen, keeping the basket
 * count honest, answering the consent notice, and switching language. Every surface here already
 * works without this file; this only makes it quicker.
 */
(function () {
  'use strict';

  var CONSENT_KEY = 'hvo-consent';

  function bindDisclosure(toggleSelector, panelSelector, onOpen) {
    var toggle = document.querySelector(toggleSelector);
    var panel = document.querySelector(panelSelector);
    if (!toggle || !panel) return;

    function set(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && onOpen) onOpen(panel);
    }

    toggle.addEventListener('click', function () { set(panel.hidden); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        set(false);
        toggle.focus();
      }
    });
  }

  function bindMenu() {
    bindDisclosure('[data-menu-toggle]', '[data-menu-panel]');
    bindDisclosure('[data-search-toggle]', '[data-search-panel]', function (panel) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }

  function bindConsent() {
    var notice = document.querySelector('[data-cookie-notice]');
    if (!notice) return;

    var stored = null;
    try {
      stored = window.localStorage.getItem(CONSENT_KEY);
    } catch (error) {
      stored = null;
    }
    notice.hidden = Boolean(stored);

    var reopen = document.querySelector('[data-cookie-reopen]');
    if (reopen) {
      reopen.addEventListener('click', function () {
        notice.hidden = false;
        notice.scrollIntoView({ block: 'nearest' });
      });
    }

    function answer(value) {
      try {
        window.localStorage.setItem(CONSENT_KEY, value);
      } catch (error) {
        /* A browser that refuses storage still gets the notice dismissed for this visit. */
      }
      notice.hidden = true;
      document.dispatchEvent(new CustomEvent('hvo:consent', { detail: { value: value } }));
    }

    var accept = notice.querySelector('[data-cookie-accept]');
    var decline = notice.querySelector('[data-cookie-decline]');
    if (accept) accept.addEventListener('click', function () { answer('accepted'); });
    if (decline) decline.addEventListener('click', function () { answer('declined'); });
  }

  function bindLanguage() {
    var select = document.querySelector('[data-language-select]');
    if (!select || !select.form) return;
    select.addEventListener('change', function () { select.form.submit(); });
  }

  function bindCartCount() {
    document.addEventListener('hvo:cart-updated', function (event) {
      var count = event.detail && event.detail.itemCount;
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = String(count);
        node.hidden = count === 0;
      });
    });
  }

  function start() {
    bindMenu();
    bindConsent();
    bindLanguage();
    bindCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
